import { Pipe, PipeTransform } from '@angular/core';

import { capitalizeWithNumericPrefix } from '../../utils/string';

@Pipe({ name: 'numericPrefixTitleCase' })
export class NumericPrefixTitleCasePipe implements PipeTransform {
  public transform(input: string): string {
    if (!input) {
      return '';
    } else {
      return capitalizeWithNumericPrefix(input);
    }
  }
}
